module.exports = __webpack_public_path__ + "assets/a-15-bingdu.c7ab1e17.svg";